const replaceUrlPattern = ($0: string): string => {
  return `<a href="${$0}" target="_blank">${makeShort($0, 40)}</a>`
}
export const replaceStringToUrl = (copy: string): string => {
  const message = copy.replace(/</g, '&lt;').replace(/>/g, '&gt;')
  const urlPattern =
    /((http|https)+:\/\/)?(www\.)?([A-Za-z0-9-])+\.(\S\.?\/?)+/gi
  return message.replace(urlPattern, replaceUrlPattern).replace(/\n/g, '')
}

export const makeShort = (copy: string, length: number): string => {
  if (copy.length <= length) {
    return copy
  }

  return `${copy.substring(0, length)}...`
}

export const makeArrow = (copy: string): string => {
  if (copy === '') return copy
  return copy.replace(/-(&gt;|>)/g, '→')
}

export const refineString = (copy: string): string => {
  return makeArrow(replaceStringToUrl(copy))
}
